const message = {
  INVALID_FILE: 'File is required.',
  INVALID_FILE_NUMBER: 'Expecting only one file at a time.',
  INVALID_FILE_TYPE: "Expecting '.pdf' file type.",
  INVALID_FILE_SIZE: 'Maximal file size is 20MB.',
};

export { message };
